// @flow
import { useMemo } from 'react';

import useMedia from './useMedia';

function useProductDetailColumnCount () {
  return useMedia(
    // Media queries
    useMemo(() => ['(min-width: 1010px)', '(min-width: 680px)'], []),
    // Column counts (relates to above media queries by array index)
    useMemo(() => [3, 2], []),
    // Default column count
    1
  );
}

export default useProductDetailColumnCount;
